export const LocalStorageKey = {
  STATIC_CONFIG: "STATIC_CONFIG",
  EXPAND: "EXPAND",
  CONFIG_COLOR: "CONFIG_COLOR",
};
